let lastWindowWidth = 0;

const register = () => {
    lastWindowWidth = $(window).outerWidth();

    $(window).on('resize', () => {
        if (lastWindowWidth === $(window).outerWidth()) {
            return;
        }

        lastWindowWidth = $(window).outerWidth();
        $(window).trigger('resize:horizontally');
    });
};

export default {
    register,
};
